import.meta.glob([ '../img/**', ]);
import NiceSelect from './../select/nice-select-updated.js';

import './scripts/accordion.js';
import './helpers/tailwind_sizes.js';
import './scripts/custom-video-player.js';
import './scripts/sliders.js';
import './scripts/header.js';
import './scripts/modal.js';
import './scripts/cases-filter.js';
import './scripts/language-switcher.js';

import '@shoelace-style/shoelace/dist/components/image-comparer/image-comparer.js';

const selects = document.querySelectorAll('select');
if (selects.length > 0) {
    selects.forEach(select=>{

        // Not the best solution to get placeholder, but it works and easy to change from WordPress.
        const selectWrapper = select.closest('.input-wrapper');
        const inputWrapperTitle = selectWrapper.dataset.title;
        const firstOption = select.options[0];

        let inputPlaceholder = '';
        if (inputWrapperTitle){
            inputPlaceholder = inputWrapperTitle;
        }else{
            inputPlaceholder = firstOption.innerText
        }

        NiceSelect.bind(select, {searchable: false, placeholder: inputPlaceholder});
        console.log(NiceSelect)
    })
}


const phoneInputs = document.querySelectorAll('input[type="tel"]');
phoneInputs.forEach(phoneInput=>{
    phoneInput.addEventListener('input', function(e) {
        let value = e.target.value;
        let newValue = value.replace(/[^\d+\s]/g, '');

        if (newValue.includes('+')) {
            if (newValue.indexOf('+') !== 0) {
                newValue = newValue.replace(/\+/g, '');
            }
            newValue = '+' + newValue.slice(1).replace(/\+/g, '');
        }

        if (value !== newValue) {
            e.target.value = newValue;
        }
    });
})





